<h1 mat-dialog-title class="dialog-header">{{ titleKey | translate }}</h1>

<mat-dialog-content class="mat-typography">
  @if (loading) {
    <div class="loading-row">
      <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
      <span>{{ "easybill.loading" | translate }}</span>
    </div>
  } @else if (!summary) {
    <div class="error-message">{{ errorMessage | translate }}</div>
  } @else {
    <div class="summary-row">
      <span class="badge badge-new">{{ "easybill.new" | translate }}: {{ summary.New }}</span>
      <span class="badge badge-updated">{{ "easybill.updated" | translate }}: {{ summary.Updated }}</span>
      <span class="badge badge-unchanged">{{ "easybill.unchanged" | translate }}: {{ summary.Unchanged }}</span>
    </div>

    @if (!summary.Changes || summary.Changes.length === 0) {
      <p class="text-gray-500">{{ "easybill.noChanges" | translate }}</p>
    } @else {
      <div class="import-list">
        @for (item of summary.Changes; track item.EasybillID) {
          <div class="import-item">
            <div class="import-item-header">
              <mat-checkbox [checked]="isSelected(item.EasybillID)" (change)="toggleItem(item.EasybillID)"></mat-checkbox>
              <span class="action-badge" [ngClass]="'action-' + item.Action">{{ ("easybill." + item.Action) | translate }}</span>
              <span class="import-item-label">{{ item.Label }}</span>
            </div>

            @if (item.Action === 'updated' && item.Diff && item.Diff.length > 0) {
              <ul class="diff-list">
                @for (d of item.Diff; track d.Field) {
                  <li>
                    <span class="diff-field">{{ d.Field }}:</span>
                    <span class="diff-before" [title]="d.Before">{{ d.Before || "–" }}</span>
                    <span class="diff-arrow">→</span>
                    <span class="diff-after" [title]="d.After">{{ d.After || "–" }}</span>
                  </li>
                }
              </ul>
            }

            @if (isOrders && isSelected(item.EasybillID) && orderState(item.EasybillID); as state) {
              <div class="order-details">
                <mat-form-field class="w-full">
                  <mat-label>{{ "easybill.assignment" | translate }}</mat-label>
                  <mat-select [(value)]="state.assignTo">
                    <mat-option value="new">{{ "easybill.newLicence" | translate }}</mat-option>
                    @for (existing of item.ExistingLicences; track existing.GUID) {
                      <mat-option [value]="existing.GUID">{{ existing.VRS }} – {{ existing.ProjectName }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (item.ExistingLicences && item.ExistingLicences.length > 0 && state.assignTo === 'new') {
                  <p class="assignment-hint">{{ "easybill.assignmentHint" | translate }}</p>
                }

                @if (item.Positions && item.Positions.length > 0) {
                  <div class="positions-list">
                    @for (position of item.Positions; track position.ProductID; let i = $index) {
                      <div class="position-row">
                        <mat-checkbox [(ngModel)]="state.positions[i].included">
                          <span class="position-product-id">{{ position.ProductID }}</span>
                          <span class="position-description" [title]="position.Label">{{ position.Label }}</span>
                        </mat-checkbox>
                        <mat-form-field class="quantity-field">
                          <mat-label>{{ "easybill.quantity" | translate }}</mat-label>
                          <input matInput type="number" min="0"
                            [(ngModel)]="state.positions[i].quantity"
                            [disabled]="!state.positions[i].included" />
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (errorMessage) {
      <div class="error-message mt-2">{{ errorMessage | translate }}</div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ "Cancel" | translate }}</button>
  <button mat-flat-button color="primary"
    [disabled]="loading || confirming || !summary || selectedIds.size === 0"
    (click)="confirm()">
    {{ confirming ? ("easybill.importing" | translate) : ("easybill.confirmImport" | translate) }}
  </button>
</mat-dialog-actions>
